module.exports = __webpack_public_path__ + "img/map_16.9a80e21f.png";